import WorkOutlineOutlined from '@mui/icons-material/WorkOutlineOutlined';
import { IAbsenteeismRateItem } from '../../../interfaces/IAbsenteeismRate';
import { AbsenteeismRateCard } from './AbsenteeismRateCard';

export const RankWorkstationWithMoreMedicalCertificate = ({ data }: { data: IAbsenteeismRateItem[] }) => (
  <AbsenteeismRateCard
    icon={<WorkOutlineOutlined />}
    title="Taxa de absenteísmo por setor"
    subtitle="Colaboradores com atestado sobre o total do setor"
    data={data}
  />
);
